export default typeof global.it === 'function'
